import http from '@/plugins/axios';

export default {
  uploadCSV(provider, data) {
    return http
      .post(`csv-import/${provider}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(res => res.data);
  },
  getMigrationStatus() {
    return http.get('csv-import-status');
  },
  deleteMigration(migrationId) {
    return http.post(`csv-import/${migrationId}/delete`);
  },
  getMigrations: ({ rowsPerPage, sortBy, descending, page, search }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
      search: search,
    };
    return http
      .get('/migrations-datatables', {
        params,
      })
      .then(res => res.data);
  },
};
